import React from "react";
import { t } from "i18next";
import useUpdateUserProfile from "service-hooks/useUpdateUserProfile";
import TextInput from "components/TextInput";
import useShowUserInfoModal from "features/basket/useShowUserInfoModal";
import SlideInLayout from "components/layouts/SlideInLayout";
import { CustomButton } from "components/Button";

const AddUserInfoForm = () => {
  const { isOpenUserInfoModal, setUserInfoModal } = useShowUserInfoModal();
  const { formstate, onFinish, updateFormState } = useUpdateUserProfile({
    setUserInfoModal,
    isOpenUserInfoModal,
  });

  const { values, errors } = formstate;
  const { name, email, loading: isLoading, error } = values;

  const stopClickPropagation = (e) => e.stopPropagation();

  const renderButton = () => {
    // const isLoading = formstate?.values?.loading;
    const buttonText = isLoading ? t("Loading") : t("Submit");
    return (
      <CustomButton
        type="submit"
        onClick={isLoading ? stopClickPropagation : onFinish}
        disabled={isLoading}
        className="cursor-pointer block text-center py-3 rounded text-brand-text-primary bg-brand-base-primary text-16x w-full"
      >
         <span className="font-bold text-center">{buttonText}</span>
      </CustomButton>
    );
  };

  return (
    <SlideInLayout
      open={isOpenUserInfoModal}
      handleClose={()=>{}}
      
      disableOutsideClick={true}
      hideOutsideCloseButton={true}
      showHeader={true}
      showHeaderCloseButton={false}
      headerTitle={t("Update your profile")}
      container={{
        style: {
          height:"fit-content",
        },
      }}
    >
      <div className="p-5 flex flex-col gap-4">
        {error && <div className="text-red-500 text-center">{error}</div>}

        <TextInput
          label={t("Your Name")}
          value={name}
          onChange={(e) => updateFormState("name", e.target.value)}
          name="mapAddress"
          mandatory={true}
          labelClasses="text-14x text-black"
          inputClasses="focus:outline-none flex-1 text-16x block w-full rounded border shadow-input px-2 py-3 border-gray-200"
          placeHolder={t("Your Name")}
          readOnly={false}
          error={errors.name}
        />

        <TextInput
          label={t("Email Address")}
          value={email}
          onChange={(e) => updateFormState("email", e.target.value)}
          name="mapAddress"
          mandatory={false}
          labelClasses="text-14x text-black"
          inputClasses="focus:outline-none flex-1 text-16x block w-full rounded border shadow-input px-2 py-3 border-gray-200 "
          placeHolder={t("Email Address")}
          readOnly={false}
          error={errors?.email}
        />
        {renderButton()}
      </div>
    </SlideInLayout>
  );
};

export default AddUserInfoForm;
